import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateFilterInterProc = atom({
  key: 'filter.interProc',
  default: null as BeaconFilterItem | null,
});

export default stateFilterInterProc;
